import { render } from "./quote-cmp.vue?vue&type=template&id=8c0b22f6&scoped=true"
import script from "./quote-cmp.vue?vue&type=script&lang=js"
export * from "./quote-cmp.vue?vue&type=script&lang=js"

import "./quote-cmp.vue?vue&type=style&index=0&id=8c0b22f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0b22f6"]])

export default __exports__